import Signal from 'libs/signals';

const userSignal = Signal({
  loaded: false,
  savedCapitalOpportunities: [],
});

export default userSignal;
